import useFaqT from "./useFaqT";
import { FAQ_COPY } from "../../constants/faq/faqStructure";

// Search field (design F1 + sheet D): 52px (48px on mobile), idle/typing
// states (accent border + glow while a query is set), Clear button when a
// query exists, meta line with result/category counts as an aria-live region.
// Live filtering across ALL visible tiers and categories — the design's
// mobile restriction to the open category was a prototype artifact and is
// deliberately NOT reproduced (work order F1).
const FaqSearch = ({ query, onQuery, onClear, resultCount, categoryCount }) => {
  const tr = useFaqT();
  const hasQuery = query.trim().length > 0;

  const meta = hasQuery
    ? `${
        resultCount === 1
          ? tr("1 result")
          : tr("{{count}} results", { count: resultCount })
      } ${
        categoryCount === 1
          ? tr("across 1 category")
          : tr("across {{count}} categories", { count: categoryCount })
      }${resultCount > 0 ? ` · ${tr("matches highlighted")}` : ""}`
    : tr("Live filtering across all categories");

  return (
    <div className="mt-6 flex max-w-[720px] flex-col gap-2.5 md:mt-7">
      <div
        className={`flex h-12 items-center gap-2.5 border bg-white px-3.5 md:h-[52px] md:gap-3 md:px-4 ${
          hasQuery
            ? "border-[#1F5EFF] shadow-[0_0_0_3px_rgba(31,94,255,.14)]"
            : "border-[#DDE0E5]"
        }`}
      >
        <span
          aria-hidden="true"
          className={`h-3.5 w-3.5 flex-none rounded-full border-2 ${hasQuery ? "border-[#1F5EFF]" : "border-[#8A919D]"}`}
        />
        <input
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          placeholder={tr(FAQ_COPY.searchPlaceholder)}
          aria-label={tr("Search the FAQ")}
          className="min-w-0 flex-1 border-0 bg-transparent text-[15px] text-[#14171C] outline-none placeholder:text-[#8A919D] md:text-[16px]"
        />
        {hasQuery && (
          <button
            type="button"
            onClick={onClear}
            className="min-h-[44px] flex-none border border-[#DDE0E5] bg-[#F5F6F8] px-2.5 py-1.5 text-[12px] text-[#5A626E] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1F5EFF] md:min-h-0"
          >
            {tr("Clear")}
          </button>
        )}
      </div>
      <div aria-live="polite" className="font-faqmono text-[11px] text-[#8A919D]">
        {meta}
      </div>
    </div>
  );
};

export default FaqSearch;
